<template>
  <NotificationBanner
    v-if="showBanner"
    :banner-content="filterBanners"
    :variable-set="variableData"
    :account-id="currentAccount"
    :account-open="account.showAccount"
    :fullscreen-banner-dismissed="fullscreenBannerDismissed"
    @fullscreen-banner-dismissed="setFullscreenBannerDismissed(true)"
  />
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex"
import cmsPreviewMixin from "@soenergy/frontend-library/src/mixins/cmsPreviewMixin"
import NotificationBanner from "./NotificationBanner.vue"
import handleBanners from "@/methods/handleBanners.js"
import homeContent from "soenergy-cms-loader!?path=account/home"
import dayjs from "dayjs"
import { formatTime } from "@soenergy/frontend-library/src/helpers/dateFormat"
import {
  GET_SWITCH_DATE,
  GET_ENERGY_ON_SUPPLY,
  GET_SMART_METER_APPOINTMENT_DATE,
  GET_SMART_METER_APPOINTMENT_TIME,
} from "@/variable_keys/Banners.js"
import { datesMixin } from "../mixins/datesMixin"

export default {
  components: {
    NotificationBanner,
  },
  mixins: [
    cmsPreviewMixin({ story: homeContent, name: "bannerContent" }),
    datesMixin,
  ],
  computed: {
    ...mapGetters({
      ready: "ready",
      isLoggedIn: "isLoggedIn",
      account: "account",
      hasSeasonalPaymentPlan: "payments/hasSeasonalPaymentPlan",
      hasActiveAgreements: "meterpointAgreements/hasActiveAgreements",
      lastReadMinMax: "meters/lastReadMinMax",
      supplyStartDates: "home/supplyStartDates",
      isSwitchComplete: "switchIn/isSwitchComplete",
      isSwitchInProgress: "switchIn/isSwitchInProgress",
      hasSmartMeter: "meters/hasSmartMeter",
      accountOpen: "account/showAccount",
      isEligibleForSmartMeter: "smbp/isEligibleForSmartMeter",
      isSwitchingAway: "switchIn/isSwitchingAway",
      hasElectricity: "meters/hasElectricity",
      hasGas: "meters/hasGas",
    }),
    ...mapState({
      smbpData: (state) => state.userStatus.userStatus.smbpData,
      fullscreenBannerDismissed: (state) =>
        state.home.fullscreenBannerDismissed,
    }),
    showBanner() {
      return (
        this.ready &&
        this.isLoggedIn &&
        this.bannerContent &&
        this.bannerContent.homeBanners &&
        !this.$route.meta.hideAccountBanner
      )
    },
    variableData() {
      return {
        [GET_SWITCH_DATE]: this.formatDate(this.sortedSupplyStartDates[0]),
        [GET_ENERGY_ON_SUPPLY]: this.energyTypesOnSupply,
        [GET_SMART_METER_APPOINTMENT_DATE]:
          this.smbpData && this.smbpData.bookingData
            ? this.formatDate(this.smbpData.bookingData.date)
            : null,
        [GET_SMART_METER_APPOINTMENT_TIME]:
          this.smbpData && this.smbpData.bookingData
            ? formatTime(this.smbpData.bookingData.startTime)
            : null,
      }
    },
    bannerData() {
      return {
        allBanners: [...this.bannerContent.homeBanners],
        hasSeasonalPaymentPlan: this.hasSeasonalPaymentPlan,
        anyOutOfContract: this.anyOutOfContract,
        hasActiveAgreements: this.hasActiveAgreements,
        lastReadMinMax: this.lastReadMinMax,
        smbpData: this.smbpData,
        dateToday: dayjs().toString(),
        variables: this.variableData,
        isSwitchComplete: this.isSwitchComplete,
        isSwitchInProgress: this.isSwitchInProgress,
        isSwitchingAway: this.isSwitchingAway,
        hasSmartMeter: this.hasSmartMeter,
        accountOpen: this.account.showAccount,
        isEligibleForSmartMeter: this.isEligibleForSmartMeter,
      }
    },
    filterBanners() {
      return handleBanners(this.bannerData)
    },
    sortedSupplyStartDates() {
      let sortDates = [...this.supplyStartDates].sort((a, b) =>
        dayjs(a).isAfter(dayjs(b)) ? 1 : 1
      )
      return sortDates
    },
    energyTypesOnSupply() {
      let energyTypesOnSupply
      if (this.hasActiveAgreements && this.hasElectricity && this.hasGas) {
        energyTypesOnSupply = "electricity and gas are "
      } else if (this.hasElectricity && !this.hasGas) {
        energyTypesOnSupply = "electricity is"
      } else if (!this.hasElectricity && this.hasGas) {
        energyTypesOnSupply = "gas is"
      }
      return energyTypesOnSupply
    },
  },
  methods: {
    ...mapMutations({
      setFullscreenBannerDismissed: "home/SET_FULLSCREEN_BANNER_DISMISSED",
    }),
  },
}
</script>
